export default {"src":"/_next/static/media/locationAlert.f86190bd.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};